/**
 * drawerCloseStyle
 *
 * Style for antd Drawer's `close` semantic slot, the header's close button. Consumers: the seven
 * drawers that take `drawerWrapperStyle` (`FormSidebar`, `CompositeFieldSidebar`, `CellDetailPanel`
 * and the four ledger drawers). It uses the same CSS step at antd `md` as `drawerWrapperStyle`: at
 * `screenMD` and wider the step is <= 0, so `max` keeps antd's own `fontSizeLG + paddingXS` square;
 * below it the step is huge, so `min` yields `controlHeight` and the button meets the 32px phone target.
 */
import type { CSSProperties } from 'react';
import type { GlobalToken } from 'antd';

export const drawerCloseStyle = (token: GlobalToken): CSSProperties => {
  const side = `max(${token.fontSizeLG + token.paddingXS}px, min(${token.controlHeight}px, calc((${token.screenMD}px - 100vw) * 10000)))`;
  return { width: side, height: side };
};
